import { useRef, useEffect, useCallback } from "react";

/**
 *
 * @returns A function that resolves to `true` if the component is mounted.
 */
export function useIsMounted() {
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return useCallback(() => mounted.current, []);
}
